import React, { createContext, PropsWithChildren, useMemo, useState } from 'react'

export interface ThreadSearchContextData {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
  searchQuery: string
  updateQuery: (s: string) => void
}

export const ThreadSearchContext = createContext<ThreadSearchContextData>({
  isOpen: false,
  onClose: () => {},
  onOpen: () => {},
  searchQuery: '',
  updateQuery: () => {},
})

export const ThreadSearchProvider = ({
  isOpen,
  onOpen,
  onClose,
  children,
}: PropsWithChildren<{
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
}>) => {
  const [searchQuery, setSearchQuery] = useState('')
  const contextData = useMemo(
    () => ({
      isOpen,
      onClose: () => {
        setSearchQuery('')
        onClose()
      },
      onOpen: () => {
        onOpen()
      },
      searchQuery,
      updateQuery: (s: string) => setSearchQuery(s),
    }),
    [isOpen, searchQuery, onOpen, onClose],
  )
  return <ThreadSearchContext.Provider value={contextData}>{children}</ThreadSearchContext.Provider>
}
